export enum AcuantCameraStateTypes {
    CAPTURING = -1,
    TAP_TO_CAPTURE = -2
}